import { randomUUID } from "crypto";
import { s as stripe } from "./stripe.js";
import { c as sendLicenseEmail } from "./mailer.js";
import { L as LicenseCollection } from "./firebase.js";
const generateLicenseAndNotifyUser = async (paymentIntent, infoText) => {
  const license = randomUUID().toUpperCase();
  const customer = await stripe.customers.retrieve(paymentIntent.customer);
  if (customer.deleted || !customer.email) return null;
  await LicenseCollection().doc(customer.email).set({
    code: license,
    issuedOn: /* @__PURE__ */ new Date()
  });
  await sendLicenseEmail(customer.email, license, infoText);
};
export {
  generateLicenseAndNotifyUser as g
};
